export const messages = {
  example: {
    title: {
      id: 'admin/promotions.form.regular.editor.benefit.formula.example.title',
    },
    first: {
      id: 'admin/promotions.form.regular.editor.benefit.formula.example.first',
    },
    second: {
      id: 'admin/promotions.form.regular.editor.benefit.formula.example.second',
    },
    third: {
      id: 'admin/promotions.form.regular.editor.benefit.formula.example.third',
    },
    link: {
      id: 'admin/promotions.form.regular.editor.benefit.formula.example.link',
    },
  },
  variable: {
    title: {
      id: 'admin/promotions.form.regular.editor.benefit.formula.variable.title',
    },
    total: {
      id: 'admin/promotions.form.regular.editor.benefit.formula.variable.total',
    },
    freight: {
      id: 'admin/promotions.form.regular.editor.benefit.formula.variable.freight',
    },
    quantity: {
      id: 'admin/promotions.form.regular.editor.benefit.formula.variable.quantity',
    },
    link: {
      id: 'admin/promotions.form.regular.editor.benefit.formula.variable.link',
    },
  },
  operation: {
    title: {
      id: 'admin/promotions.form.regular.editor.benefit.formula.operation.title',
    },
    sum: {
      id: 'admin/promotions.form.regular.editor.benefit.formula.operation.sum',
    },
    subtraction: {
      id: 'admin/promotions.form.regular.editor.benefit.formula.operation.subtraction',
    },
    multiplication: {
      id: 'admin/promotions.form.regular.editor.benefit.formula.operation.multiplication',
    },
    division: {
      id: 'admin/promotions.form.regular.editor.benefit.formula.operation.division',
    },
    link: {
      id: 'admin/promotions.form.regular.editor.benefit.formula.operation.link',
    },
  },
  function: {
    title: {
      id: 'admin/promotions.form.regular.editor.benefit.formula.function.title',
    },
    min: {
      id: 'admin/promotions.form.regular.editor.benefit.formula.function.min',
    },
    max: {
      id: 'admin/promotions.form.regular.editor.benefit.formula.function.max',
    },
    floor: {
      id: 'admin/promotions.form.regular.editor.benefit.formula.function.floor',
    },
    link: {
      id: 'admin/promotions.form.regular.editor.benefit.formula.function.link',
    },
  },
}
